// extracted by mini-css-extract-plugin
module.exports = {"root":"InputSecondary_root__4MBj7","error":"InputSecondary_error__3af_z","disabled":"InputSecondary_disabled__1webD"};